<template>
  <Accordion
    :Heading="shadeGrouping"
    :Title1="defaultColor"
    :Value1="selectedDefaultColor"
    :options="options"
    :Title3="shadeConfiguration"
    :isEnable="isEnable"
  >
    <div class="inputs">
      <div class="card bg-white mb-3" style="width: 100%; border-radius: 10px">
        <div class="card-body">
          <table class="table table-bordered">
            <tbody>
              <tr>
                <td>
                  <DropdownComp
                    :options="options"
                    @toggleEventChange="toggleEvent"
                    :toggleButtonVal="toggleButtonValue"
                    :selectedDefaultColor="selectedDefaultColor"
                    @changeDefaultColorSelectorValue="changeDefaultColorSelectorValue"
                  ></DropdownComp>
                </td>
              </tr>
              <tr>
                <th style="background: #dee2e6" scope="col">
                  <div class="ml-5" style="display: flex; justify-content: left">
                    <div>{{ $t("shadeGrouping.colors") }}</div>
                    <div class="ml-5 pl-5">{{ $t("shadeGrouping.shades") }}</div>
                  </div>
                </th>
              </tr>
              <tr>
                <td>
                  <GridLoading v-if="showLoader"></GridLoading>
                  <ShadingComponent
                    v-else
                    :options="options"
                    :inputData="inputData"
                    @handleRemoveShade="handleRemoveShade"
                    @handleAddShade="handleAddShade"
                    @getShadeName="getShadeName"
                    @getShadeValue="getShadeValue"
                    @handleUpdate="handleUpdate"
                    @editShade="editShade"
                    :isActive="toggleButtonValue"
                  ></ShadingComponent>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </Accordion>
</template>
<script lang="ts">
import Accordion from "@/app/views/_components/Accordion.vue";
import ShadingComponent from "@/app/views/_components/ShadingComp.vue";
import DropdownComp from "@/app/views/_components/DropdownComp.vue";
import GridLoading from "@/app/views/_components/GridLoading.vue";
import { ShadeApi, UserAdminSettingApi, StyleOperationStitchNBLCApi, ColorGroupApi } from "@/api";
import { ShadeCreateDto, ConfigurationUpdateDto } from "@/api/model";
import { defineComponent } from "vue";
import { useToast } from "vue-toastification";

export default defineComponent({
  name: "ShadeGrouping",
  components: { Accordion, ShadingComponent, GridLoading, DropdownComp },
  setup() {
    const shadeApi = new ShadeApi()!;
    const userAdminSettingApi = new UserAdminSettingApi()!;
    const styleOperationStitchNBLCApi = new StyleOperationStitchNBLCApi()!;
    const colorGroupApi = new ColorGroupApi()!;
    return {
      shadeApi,
      userAdminSettingApi,
      styleOperationStitchNBLCApi,
      colorGroupApi
    };
  },
  data() {
    return {
      colorGroupData: [] as any,
      shadeName: "" as any,
      shadeValue: "" as any,
      toggleButtonValue: (localStorage.getItem("toggleButtonVal") == "true") as any,
      showLoader: false as any,
      selectedDefaultColor: "" as any,
      isEnable: "" as any,
      shadeGrouping: this.$t("shadeGrouping.shadeGrouping") as any,
      defaultColor: this.$t("shadeGrouping.defaultColor") as any,
      shadeConfiguration: this.$t("shadeGrouping.shadeConfiguration") as any,
      success: this.$t("shadeGrouping.success") as any,
      error: this.$t("shadeGrouping.error") as any,
      shadeAddedSuccessfully: this.$t("shadeGrouping.shadeAddedSuccessfully") as any,
      duplicateNameOrValue: this.$t("shadeGrouping.duplicateNameOrValue") as any,
      shadeIsUsedInAStyle: this.$t("shadeGrouping.shadeIsUsedInAStyle") as any,
      shadeCannotBeRemoved: this.$t("shadeGrouping.shadeCannotBeRemoved") as any,
      enable: this.$t("shadeGrouping.enable") as any,
      disable: this.$t("shadeGrouping.disable") as any,
      duplicateShade: this.$t("shadeGrouping.duplicateShadeName") as any,
      shadeNameCanNotBeEmpty: this.$t("shadeGrouping.shadeNameCanNotBeEmpty") as any,
      shadeUpdatedSuccessfully: this.$t("shadeGrouping.shadeUpdatedSuccessfully") as any,
      shadeCanNotBeUpdated: this.$t("shadeGrouping.shadeCanNotBeUpdated") as any,
      shadeReplacedSuccessfully: this.$t("shadeGrouping.shadeReplacedSuccessfully") as any,
      shadeCanNotBeReplaced: this.$t("shadeGrouping.shadeCanNotBeReplaced") as any,
      shadeDataArray: [] as any,
      options: [] as any,
      inputData: {
        C: [],
        B: [],
        N: [],
        U: [],
        W: []
      } as any,
      toast: null as any
    };
  },
  created(): any {
    this.toast = useToast();
    this.onMountAdminSettings();
    this.getColorGroupData();
  },
  mounted(): any {
    this.onGettingShadeData();
  },
  methods: {
    async getColorGroupData(): Promise<void> {
      await this.colorGroupApi.apiColorGroupGet().then(res => {
        this.colorGroupData = res.data;
      });
      this.setColorGroupData();
    },
    setColorGroupData(): void {
      this.options.push(
        {
          name: "C",
          value: "Colors (C)",
          Id: this.colorGroupData?.items.find((x: { name: string }) => x.name == "C").id
        },
        {
          name: "B",
          value: "Black (B)",
          Id: this.colorGroupData?.items.find((x: { name: string }) => x.name == "B").id
        },
        {
          name: "N",
          value: "Naturals (N)",
          Id: this.colorGroupData?.items.find((x: { name: string }) => x.name == "N").id
        },
        {
          name: "U",
          value: "Unbleached (U)",
          Id: this.colorGroupData?.items.find((x: { name: string }) => x.name == "U").id
        },
        {
          name: "W",
          value: "Whites (W)",
          Id: this.colorGroupData.items.find((x: { name: string }) => x.name == "W").id
        }
      );
    },
    async handleRemoveShade(categoryName: string, shadeValue: string): Promise<void> {
      let index = this.inputData[categoryName].findIndex(function (o: any) {
        return o.value === shadeValue;
      });
      if (index !== -1) this.inputData[categoryName].splice(index, 1);
    },
    getShadeName(event: string): void {
      this.shadeName = event.trim();
    },
    toggleEvent(value: boolean): void {
      this.toggleButtonValue = value;
      this.isEnable = value ? this.enable : this.disable;
    },
    getShadeValue(event: string): void {
      this.shadeValue = event;
    },
    editShade(newShadeVal: string, categoryVal: string, oldShadeVal: string, oldShadeName: string): void {
      let newData: any = {
        value: newShadeVal,
        name: oldShadeName
      };
      let index = this.inputData[categoryVal].findIndex(function (o: any) {
        return o.value === oldShadeVal;
      });
      if (index !== -1) {
        this.inputData[categoryVal].splice(index, 1);
        this.inputData[categoryVal].push(newData);
        this.toast.success(this.shadeUpdatedSuccessfully, {
          toastClassName: "custom-success-toast",
          timeout: 5000
        });
      }
    },
    changeDefaultColorSelectorValue(defaultColorValue: string): void {
      this.selectedDefaultColor = defaultColorValue;
    },
    findDuplicateShade(data: any, containShade: any) {
      let colorValue = "";
      for (const shade of this.options) {
        if (containShade == 0) {
          for (let shadeVal of this.inputData[shade.name]) {
            if (shadeVal.name.toLowerCase().trim() == data.name.toLowerCase().trim()) {
              colorValue = shade.name;
              containShade++;
              break;
            }
          }
        } else {
          break;
        }
      }
      return colorValue;
    },
    handleAddShade(category: string): void {
      if (this.shadeName == "") {
        this.toast.error(this.shadeNameCanNotBeEmpty, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      } else {
        let data: any = {
          value: this.shadeValue,
          name: this.shadeName
        };
        let containShade = 0;
        let colorValue = this.findDuplicateShade(data, containShade);
        if (containShade == 0) {
          this.inputData[category].push(data);
          this.toast.success(this.shadeAddedSuccessfully, {
            toastClassName: "custom-success-toast",
            timeout: 5000
          });
        } else {
          this.IsShadeUsed(colorValue, category, data);
        }
      }
    },
    IsShadeUsed(colorValue: any, category: any, data: any) {
      let shadeIsUsed = false;
      for (let x of this.shadeDataArray) {
        if (x != null && x.toLowerCase().trim() == this.shadeName.toLowerCase().trim()) {
          shadeIsUsed = true;
        }
      }
      if (shadeIsUsed) {
        this.toast.error(this.shadeIsUsedInAStyle, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      } else {
        let index = this.inputData[colorValue].findIndex((o: any) => {
          return o.name.toLowerCase() === this.shadeName.toLowerCase();
        });
        if (index !== -1) {
          this.inputData[colorValue].splice(index, 1);
          this.inputData[category].push(data);
          this.toast.success(this.shadeReplacedSuccessfully, {
            toastClassName: "custom-success-toast",
            timeout: 5000
          });
        }
      }
    },
    async onGettingShadeData(): Promise<void> {
      await this.styleOperationStitchNBLCApi.apiGetUniqueUsedShadesGet().then(async res => {
        this.shadeDataArray = res.data;
      });
      this.getShadeValueData();
    },
    async onMountAdminSettings(): Promise<void> {
      await this.userAdminSettingApi
        .apiSystemConfigurationGet()
        .then(async e => {
          this.selectedDefaultColor = e.data.defaultColorValue;
          let toggleButtonValVar = e.data.toggleButtonValue;
          if (toggleButtonValVar == "true") this.isEnable = this.enable;
          else this.isEnable = this.disable;
          localStorage.setItem("toggleButtonVal", toggleButtonValVar?.toString == undefined ? "" : toggleButtonValVar);
        })
        .catch(e => {
          this.toast.error(e.errorMsg, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
        })
        .finally(() => {
          //
        });
    },
    async getShadeValueData(): Promise<void> {
      await this.shadeApi.apiShadeGet("name", 0, 1000).then(async res => {
        for (let item of res.data.items ?? []) {
          this.showShadeData(item.name as string, item.hexCodeValue as string, item.colorGroupId as number);
        }
      });
    },
    showShadeData(itemName: string, itemValue: string, id: number): void {
      let data: any = {
        name: itemName,
        value: itemValue,
        isUsed: false
      };
      let IsShadeUsed = this.shadeDataArray.includes(data.name);
      if (IsShadeUsed) data.isUsed = true;
      switch (id) {
        case this.colorGroupData?.items.find((x: { name: string }) => x.name == "W").id:
          this.inputData["W"].push(data);
          break;
        case this.colorGroupData?.items.find((x: { name: string }) => x.name == "B").id:
          this.inputData["B"].push(data);
          break;
        case this.colorGroupData?.items.find((x: { name: string }) => x.name == "U").id:
          this.inputData["U"].push(data);
          break;
        case this.colorGroupData?.items.find((x: { name: string }) => x.name == "N").id:
          this.inputData["N"].push(data);
          break;
        case this.colorGroupData?.items.find((x: { name: string }) => x.name == "C").id:
          this.inputData["C"].push(data);
          break;
        default:
          break;
      }
    },
    async handleUpdate(): Promise<void> {
      let flag = false;
      this.showLoader = true;
      let toggleButtonVal = this.toggleButtonValue ? "true" : "false";
      let shadeValueArray: Array<ShadeCreateDto> = [];
      localStorage.setItem("toggleButtonVal", this.toggleButtonValue);
      const ConfigurationUpdateDto: ConfigurationUpdateDto = {
        defaultColorValue: this.selectedDefaultColor,
        toggleButtonValue: toggleButtonVal
      } as ConfigurationUpdateDto;
      await this.userAdminSettingApi
        .apiUpdateSystemConfigurationPost(ConfigurationUpdateDto)
        .then(() => {
          //
        })
        .then()
        .catch(e => {
          this.toast.error(e.errorMsg, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
        });
      for (let optionVal of this.options) {
        for (let inputDataVal of this.inputData[optionVal.name]) {
          const shadeValue: ShadeCreateDto = {
            colorGroupId: optionVal.Id,
            name: inputDataVal.name,
            hexCodeValue: inputDataVal.value
          } as ShadeCreateDto;
          shadeValueArray.push(shadeValue);
        }
      }
      await this.shadeApi
        .apiShadeUpdateShadesPost(shadeValueArray)
        .then(() => {
          flag = true;
          this.showLoader = false;
        })
        .catch(e => {
          this.showLoader = false;
          this.toast.error(e.errorMsg, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
        });
      if (flag) {
        this.toast.success(this.success, {
          toastClassName: "custom-success-toast",
          timeout: 5000
        });
      } else {
        this.toast.error(this.error, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
    }
  }
});
</script>
<style scoped>
.cont {
  background-color: rgb(88 89 91 / 10%);
  height: 42px;
  display: flex;
  padding: 9px;
  margin-top: -30px;
}
.shadeTitle {
  margin-left: 5rem;
  font-size: 18px;
  color: 646262;
  font-weight: 700;
}
.color {
  margin-left: 2rem;
  font-size: 18px;
  color: 646262;
  font-weight: 700;
}
</style>
